import styled from "styled-components";
import grain from "./../../assets/images/grain.svg";
import Lottie from "lottie-react";

export const Container = styled.div`
  background-color: #463048;
  background-image: url(${grain});
  background-blend-mode: multiply;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 380px;
`;

export const GamePad = styled.div`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1px;
  background-color: #d09400;
`;

export const Box = styled.div`
  height: 46px;
  width: 46px;
  background-color: #f8c933;
  background-image: url(${grain});
  background-blend-mode: multiply;
`;

export const LottieAnimation = styled(Lottie)`
  height: 180px;
  width: 180px;
`;

export const PlayGround = styled.div`
  aspect-ratio: (1 / 2);
  flex-direction: column;
  max-width: 380px;
  display: flex;
`;

export const MatchBoxStrip = styled.img`
  width: 100%;
  height: 20px;
`;

export const CenterArea = styled.div`
  background-color: #463048;
  width: 380px;
  height: 500px;
  display: flex;
  color: #171312;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-size: cover;
  background-repeat: no-repeat;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Header = styled.span`
  display: flex;
  text-align: center;
  padding-left: 30px;
  padding-right: 30px;
  color: #f8c933;
  font-size: 20px;
  margin-top: 20px;
  letter-spacing: 1px;
  max-width: 350px;
`;

export const BottomText = styled.span`
  color: #f8c933;
  padding-right: 10px;
`;

export const TutorialContentArea = styled.div`
  background-color: red;
`;

export const LeftRightArrow = styled.button`
  background-color: #463048;
  border-radius: 100%;
  width: 50px;
  height: 50px;
  border: none;
  cursor: pointer;
  :active {
    background:pink;
    transform: translateY(1px);
  }
`;

export const DiceButton = styled.button`
  margin: 10px 10px 10px 10px;
  background: none;
  background-color: orange;
  background-image: url(${grain});
  background-blend-mode: multiply;
  border: none;
  height: 76px;
  width: 84px;
`;
